// extracted by mini-css-extract-plugin
export var button = "_o5-0";